import { render } from "./menu.vue?vue&type=template&id=2974056e&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=2974056e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2974056e"]])

export default __exports__